import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class externalMailingListEdit_template extends vnTemplate {

    protected getTemplateHtml(): string {
        return `
            <div class="form-header">
                <h3 class="form-title">Mailing List</h3>
                <button data-bind="event: { click: onClickCancelEdit }" class="close-button icon i-close-2" type="button"></button>
            </div>
            <div class="w-form-body">
                <div class="form-body">
                    <div class="form-group row">
                        <label for="idMailingList" class="form-label form-label form-label-box">Mailing List ESP ID</label>
                        <input type="text" class="input-text" data-bind="value: idMailingList">
                    </div>
                    <div class="form-group row">
                        <label for="label" class="form-label form-label form-label-box">Mailing List Label</label>
                        <input type="text" class="input-text" data-bind="value: label">
                    </div>
                </div>      
            </div>
             <div class="form-footer">                
                <button data-bind="event: { click: onClickCancelEdit }" class="btn" type="button">Cancel</button>
                <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>            
            </div> 
            `;
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-form"];
    }

    protected buildViewModel(): any {
        let self = this
        return {
            id: ko.observable("")
            , idMailingList: ko.observable("")
            , label: ko.observable("")
            , onClickCancelEdit: function (data, event) {
                self.onClickCancelEdit();

            },onClickSave: function (data, event) {
                self.onClickSave()
            }
        }
    }

    protected getTemplateName(): string {
        return "mailingListEdit_template";
    }

    public setId(id){
        this.getTemplateViewModel().id(id)
    }

    public setIdMailingList(idMailingList){
        this.getTemplateViewModel().idMailingList(idMailingList)
    }

    public setLabel(label){
        this.getTemplateViewModel().label(label)
    }

    protected onClickCancelEdit(): any {
        this.caller.onClickCancelEdit();
    }

    protected onClickSave(): any {
        this.caller.save()
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/externalMailingListEdit_template.ts